import React from 'react';
import ProjectContainer from '../../containers/projectmng/ProjectContainer';

const EtcDetailPage = () => {
  const pageUrl="/maintancetmng";
  return <ProjectContainer pageUrl={pageUrl}/>
};

export default EtcDetailPage;
